function Spinner({cls}) {
    return (
        <div>
            <span className={`spinner ${cls ? cls : ""}`}></span>
        </div>
    )
}

export default Spinner;